// extracted by mini-css-extract-plugin
module.exports = {"map":"BarChart_map__3J1EV","wrapper":"BarChart_wrapper__2c1i0"};